// extracted by mini-css-extract-plugin
export default {"div":"CreatedTransaction_div__arTmt","p":"CreatedTransaction_p__GRIU1","button":"CreatedTransaction_button__89XqF"};